import Vue from 'vue';
import Vuex from 'vuex';
import session from './modules/session';
import pop from './modules/pop';
import medal from './modules/medal';
import mnCheck from './modules/mnCheck';
import ui from './modules/ui';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

var store = new Vuex.Store({
  modules: {
    session,
    pop,
    medal,
    mnCheck,
    ui
  },
  plugins: [createPersistedState()]
});

export default store